import { render } from "./RModal.vue?vue&type=template&id=f3287922"
import script from "./RModal.vue?vue&type=script&lang=js"
export * from "./RModal.vue?vue&type=script&lang=js"

import "./RModal.vue?vue&type=style&index=0&id=f3287922&lang=css"
script.render = render

export default script